export default {
  SET_TEMPLATES: (state, { type, list }) => {
    state.templates[type] = list;
  },
  SET_WORKFLOW_TEMPLATE_DEFAULTS: (state, payload) => {
    state.workflowTemplateDefaults = payload;
  },
};
